import { render, staticRenderFns } from "./theme-banner-rule-button.vue?vue&type=template&id=b2cb2c30&scoped=true"
import script from "./theme-banner-rule-button.vue?vue&type=script&lang=js"
export * from "./theme-banner-rule-button.vue?vue&type=script&lang=js"
import style0 from "./theme-banner-rule-button.vue?vue&type=style&index=0&id=b2cb2c30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cb2c30",
  null
  
)

export default component.exports